import React from 'react'
import TruckIcon from '../Logos/truck.svg'
import PercentIcon from '../Logos/percentage.svg'
import HeadPhoneIcon from '../Logos/headset.svg'
import '../Style/Shoar.css'

function Shoar_Com() {
  return (
    <>
        <div className='shoar-container'>
            <div className='delivery-column'>
                <img src={TruckIcon}/>
                <div className='text'>تحویل در کمترین زمان ممکن</div>
            </div>
            <div className='admin-column'>
                <img src={HeadPhoneIcon}/>
                <div className='text'>پشتیبانی سریع</div>
            </div>
            <div className='offer-column'>
                <img src={PercentIcon}/>
                <div className='text'>بهترین تخفیف ها</div>
            </div>
        </div>
    </>
  )
}

export default Shoar_Com